import React from 'react'
import ContainerQrCodes from './ContainerQrCodes'
import { useParams } from 'react-router-dom'
import { AppBar, Button, IconButton, Toolbar, Typography } from '@mui/material'

export default function ContainerQrCodesPage() {

    const params = useParams()
    const uniqueId: string = params.unique_id ? params.unique_id : ""

    return(
        <div className="qr-codes-page-container">

            <AppBar className="default-mui-app-bar" sx={{ position: 'relative' }}>
                    <Toolbar>

                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            QR Codes
                        </Typography>
                    
                        <Button className="general-button admin-style light-button" color="success" onClick={() => window.print()}>
                            Print
                        </Button>

                    </Toolbar>
            </AppBar>

            <div className="content-of-qr-codes-page-container">
                <div className="qr-codes-a4-page">
                    <ContainerQrCodes uniqueId={uniqueId} />
                </div>
            </div>
        </div>
    )
}